import WhatsAppIcon from './WhatsAppIcon'
import WhatsAppMessage from './WhatsAppMessage'
import * as S from '../styled'

const WhatsAppDisclaimer = () => (
    <S.Disclaimer>
      <WhatsAppIcon />
      <WhatsAppMessage />
    </S.Disclaimer>
)

export default WhatsAppDisclaimer
